
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.759 12.462a.468.468 0 00.459.376H14.25v-8.24H2.218c-.16 0-.316-.022-.468-.059v7.831l.009.092zm13.991.518a1.36 1.36 0 01-1.358 1.358H2.218A1.968 1.968 0 01.26 12.565l-.01-.195V2.632A1.968 1.968 0 012.218.664h10.347l.077.004a.75.75 0 010 1.492l-.077.004H2.218a.469.469 0 00-.468.468l.009.09a.468.468 0 00.459.377h12.174c.315 0 .618.11.86.307l.1.091.09.1c.198.241.308.546.308.861v8.521z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M11.249 9.326a.913.913 0 100-1.826.913.913 0 000 1.826z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M11.892 8.413l-.013-.13a.644.644 0 00-.5-.5l-.13-.013a.643.643 0 00-.643.643l.013.13c.06.293.32.513.63.513v.27l-.094-.005a.913.913 0 111.007-.908l-.005.094a.913.913 0 01-.908.82v-.271c.31 0 .57-.22.63-.513l.013-.13z","fill":"#4A4A4A"}})])
          )
        }
      }
    